import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import React from 'react';
import { hubBootstrapResource } from '@atlassian/company-hub-common';
import { hubResource } from '../services/resources';
import { HubApp } from '../ui/hub';
import { HUB_ROUTE_NAME, HUB_ROUTE_PATH } from './constants';
export var hubRoute = {
  component: HubApp,
  exact: true,
  name: HUB_ROUTE_NAME,
  resources: [hubBootstrapResource, hubResource],
  path: HUB_ROUTE_PATH
};
export var createRouteWithHubShell = function createRouteWithHubShell(hubAppProps) {
  var HubAppComponent = function HubAppComponent() {
    return /*#__PURE__*/React.createElement(HubApp, hubAppProps);
  };
  return _objectSpread(_objectSpread({}, hubRoute), {}, {
    component: HubAppComponent
  });
};